import React from 'react';
import { css, cx } from 'styled-system/css';

import type { Tone } from '@shaojiang/theme/preset/recipes/site/tones';

const swatch = css({
  display: 'inline-block',
  flexShrink: '0',
  w: '9',
  h: '9',
  borderRadius: '6px',
  rotate: '-6deg',
});

const fills: Record<Tone, string> = {
  cobalt: css({ bg: 'cobalt.500' }),
  tomato: css({ bg: 'tomato.500' }),
  leaf: css({ bg: 'leaf.500' }),
  sun: css({ bg: 'sun.400' }),
  sky: css({ bg: 'sky.200' }),
  blush: css({ bg: 'blush.300' }),
};

/** A small tilted paint square (Storybook's chapter markers). */
export function Swatch({ tone, className }: { tone: Tone; className?: string }) {
  return <span className={cx(swatch, fills[tone], className)} aria-hidden />;
}
